module.exports = __webpack_public_path__ + "Gotham-Rounded-Book.d31d488d2171c1668c15.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/Admin/Documents/Dev Projects/search-artist/src/assets/fonts/Gotham-Rounded-Book.ttf
// module id = ../../../../../src/assets/fonts/Gotham-Rounded-Book.ttf
// module chunks = styles